import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Show({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Show.Outline {...props} /> : <Show.Solid {...props} />;
}

Show.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.91 13.7747C20.3389 13.0196 20.5 12.4031 20.5 12C20.5 11.597 20.3389 10.9804 19.91 10.2254C19.4912 9.48838 18.8653 8.70622 18.0689 7.99107C16.4656 6.55134 14.3082 5.5 12 5.5C9.69181 5.5 7.53446 6.55135 5.93113 7.99109C5.13472 8.70625 4.50879 9.48841 4.09004 10.2254C3.66105 10.9805 3.5 11.597 3.5 12C3.5 12.4031 3.66105 13.0196 4.09004 13.7746C4.50878 14.5116 5.13471 15.2938 5.93112 16.0089C7.53445 17.4487 9.69181 18.5 12 18.5C14.3082 18.5 16.4656 17.4487 18.0689 16.009C18.8653 15.2938 19.4912 14.5117 19.91 13.7747ZM12 20C17.5228 20 22 15.0001 22 12C22 9 17.5228 4 12 4C6.47715 4 2 9.00006 2 12C2 15 6.47715 20 12 20Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5833 14.0599C11.1296 14.4356 11.8028 14.5789 12.4548 14.4583C13.1067 14.3377 13.6841 13.963 14.0598 13.4167C14.4356 12.8704 14.5789 12.1972 14.4583 11.5453C14.3377 10.8933 13.963 10.3159 13.4167 9.9402C12.8704 9.56447 12.1972 9.42114 11.5452 9.54175C10.8933 9.66236 10.3159 10.037 9.94017 10.5833C9.56444 11.1296 9.42111 11.8028 9.54172 12.4548C9.66233 13.1068 10.037 13.6841 10.5833 14.0599ZM12.7276 15.9333C11.6845 16.1263 10.6074 15.8969 9.73328 15.2958C8.8592 14.6946 8.25973 13.7708 8.06675 12.7277C7.87378 11.6845 8.1031 10.6074 8.70427 9.73331C9.30544 8.85923 10.2292 8.25976 11.2724 8.06678C12.3155 7.87381 13.3926 8.10313 14.2667 8.7043C15.1408 9.30547 15.7403 10.2292 15.9332 11.2724C16.1262 12.3156 15.8969 13.3927 15.2957 14.2668C14.6946 15.1408 13.7708 15.7403 12.7276 15.9333Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Show.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <g fill="currentColor">
        <path d="M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z" />
        <circle cx="12" cy="12" r="2" />
      </g>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
